export default __webpack_public_path__ + "static/media/autonomy.7ba2147e.webp";